import { v4 as uuidv4 } from "uuid";
import type { RootBlock } from "@circle-react-shared/BuilderUI/DataModel.types";

export const defaultData: RootBlock = {
  id: uuidv4(),
  type: "root",
  props: {
    children: {
      prop: "children",
      type: "children",
      value: [],
    },
  },
};
